<template>
  <div class="login-login">
    <div class="login-nav">
      <div class="login-header">
        <span>学校后台管理系统</span>
      </div>
      <div class="login-form">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          class="user-layout-login"
          @submit="handleSubmit"
        >
          <a-form-model-item label="" prop="username">
            <a-input
              type="text"
              v-model="form.username"
              placeholder="账户"
              size="large"
              @keyup.enter.native="handleSubmit"
            >
              <a-icon
                slot="prefix"
                type="user"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-model-item>
          <a-form-model-item prop="password">
            <a-input
              type="password"
              v-model="form.password"
              placeholder="密码"
              size="large"
              @keyup.enter.native="handleSubmit"
            >
              <a-icon
                slot="prefix"
                type="lock"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-model-item>

          <a-form-model-item style="margin-top: 24px;">
            <a-button
              size="large"
              type="primary"
              @click="handleSubmit"
              class="login-button"
              :loading="loginBtn"
              :disabled="loginBtn"
              >确定</a-button
            >
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="login-footer-text">
        Copyright © 2022. All Rights Reserved. {{ config.companyName }} 版权所有
      </div>
    </div>
  </div>
</template>

<script>
import { Login } from "@/api";
import storage from "@/utils/storage";
// import store from "@/store";
import { ACCESS_TOKEN } from "@/utils/mutation-types";

export default {
  data() {
    return {
      loginBtn: false,
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "请输入帐户名!",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleSubmit() {
      this.loginBtn = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Login.check_login(this.form)
            .then(res => {
              console.log(res);
              if (res.code == 200) {
                storage.set(ACCESS_TOKEN, res.data, 7 * 24 * 60 * 60 * 1000);
                this.$router.replace("/");
              } else {
                this.pubMsg.tipNotification(res.message);
              }
              this.loginBtn = false;
            })
            .catch(() => {
              this.loginBtn = false;
            });
        } else {
          this.loginBtn = false;
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
@import "./login.less";
</style>
